import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 开票状态
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    // 返回不会有2 专门用来查询
    PENDING_CONFIRMATION = new Meta(2, "待确认");
    //  根据billType 是2 那你就显示确认中 如果是1 那就是待确认
    CONFIRMING = new Meta(3, "确认中");
    REJECTED = new Meta(4, "已驳回");
    COMPLETED = new Meta(5, "开票完成");
    INVALIDING = new Meta(6, "作废中");
    INVALID = new Meta(7, "已作废");
}

export const STATE = new State();

// 采购方发起 开票状态
class BuyState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    //  根据billType 是2 那你就显示确认中 如果是1 那就是待确认
    CONFIRMING = new Meta(3, "确认中");
    COMPLETED = new Meta(5, "开票完成");
}

export const BUY_STATE = new BuyState();

// 销售方发起 开票状态
class SellState extends UltMeta {
    CONFIRMING = new Meta(3, "待确认");
    COMPLETED = new Meta(5, "开票完成");
}

export const SELL_STATE = new SellState();

/**
 * 类型
 */
class Type extends UltMeta {
    BUY = new Meta(1, "采购");
    SELL = new Meta(2, "销售");
}

export const TYPE = new Type();

/**
 * 开票类型
 */
class BillType extends UltMeta {
    BUY = new Meta(1, "采购方发起");
    SELL = new Meta(2, "销售方发起");
}

export const BILL_TYPE = new BillType();

/**
 * 保存方式枚举
 */
class HasSubmit extends UltMeta {
    SAVE_AS_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_SUBMIT = new Meta(2, "保存并提交");
}

export const HAS_SUBMIT = new HasSubmit();
